// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles common to all components. */
.election-stats-icu {
  box-sizing: content-box;
  font-family: "Open Sans", Arial, sans-serif;
}
.election-stats-icu p {
  margin-bottom: 1rem;
  font-size: inherit;
  line-height: 1.6;
  text-rendering: optimizeLegibility;
}
.election-stats-icu h1, .election-stats-icu h2, .election-stats-icu h3, .election-stats-icu h4, .election-stats-icu h5, .election-stats-icu h6 {
  margin: 0;
  padding: 0;
  font-weight: 700;
  letter-spacing: normal;
}
.election-stats-icu h1::after, .election-stats-icu h2::after, .election-stats-icu h3::after, .election-stats-icu h4::after, .election-stats-icu h5::after, .election-stats-icu h6::after {
  display: none;
}
.election-stats-icu span[data-tooltip]:not([data-tooltip=""]) {
  position: relative;
  text-decoration: underline dotted;
}
.election-stats-icu span[data-tooltip]:not([data-tooltip=""]):hover::before, .election-stats-icu span[data-tooltip]:not([data-tooltip=""]):focus::before, .election-stats-icu span[data-tooltip]:not([data-tooltip=""]):active::before {
  content: attr(data-tooltip);
  display: block;
  position: absolute;
  z-index: 3;
  top: 0.5em;
  right: 3em;
  width: 20em;
  line-height: 1.2;
  background-color: white;
  color: black;
  border: 1px solid #888;
  padding: 0.5em;
  font-size: 1em;
  font-weight: 400;
}
.election-stats-icu h2 span[data-tooltip]:not([data-tooltip=""]):hover::before, .election-stats-icu h2 span[data-tooltip]:not([data-tooltip=""]):focus::before, .election-stats-icu h2 span[data-tooltip]:not([data-tooltip=""]):active::before {
  font-size: 0.5em;
}

.text-center {
  text-align: center;
}

.show-for-sr {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
/* ElectionCountdown component styles. */
.ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_timeRow__c8f4e638 {
  display: flex;
  text-align: center;
  justify-content: space-around;
  align-items: center;
  color: white;
}
.ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_header__c8f4e638 {
  max-width: 17%;
  margin-bottom: 0;
  color: #ffa900;
  font-size: 0.75em;
  font-weight: 700;
}
.ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_time__c8f4e638 {
  text-align: center;
}
.ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_time__c8f4e638 .ElectionCountdown_module_count__c8f4e638 {
  padding: 0 0.5em;
  font-size: 1.8em;
  font-weight: 800;
}
.ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_time__c8f4e638 .ElectionCountdown_module_label__c8f4e638 {
  font-size: 0.8em;
  font-weight: 700;
}
.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_dashboardCountdown__c8f4e638 .ElectionCountdown_module_timeRow__c8f4e638 {
  justify-content: space-between;
  padding: 0 0.75em 0 0.55em;
}
.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_dashboardCountdown__c8f4e638 .ElectionCountdown_module_header__c8f4e638 {
  max-width: 100%;
  font-size: 1.125em;
  margin: unset;
}
.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 {
  padding-bottom: 1em;
}
.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 .ElectionCountdown_module_timeRow__c8f4e638 {
  color: #390099;
}
.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 .ElectionCountdown_module_header__c8f4e638 {
  color: #390099;
}
.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 .ElectionCountdown_module_time__c8f4e638 {
  display: flex;
  flex-direction: column;
}
.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 .ElectionCountdown_module_time__c8f4e638 .ElectionCountdown_module_count__c8f4e638 {
  color: white;
}

@media screen and (max-width: 848px) {
  .ElectionCountdown_module_countdown__c8f4e638 {
    margin: 0.5em 0.5em 1em;
  }
  .ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_time__c8f4e638 {
    display: flex;
    flex-direction: column;
  }
  .ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 {
    padding-bottom: 0;
    margin-bottom: 0.5em;
  }
  .ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 .ElectionCountdown_module_time__c8f4e638 .ElectionCountdown_module_count__c8f4e638 {
    color: #9e0059;
  }
}
/* Styles for the Button component */
.Button_module_button__f16ab410 {
  display: inline-block;
  padding: 0.75em 0.9em;
  border: 1px solid transparent;
  vertical-align: middle;
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
  font-size: 0.9em;
  font-family: inherit;
  -webkit-appearance: none;
  line-height: 1;
  text-align: center;
  cursor: pointer;
  background-color: #390099;
  color: #ffa900;
  box-shadow: 0.16em 0.16em 0 0 #ff005c;
}
.Button_module_button__f16ab410:hover {
  background-color: #9e0059;
}
.Button_module_button__f16ab410.Button_module_small__f16ab410 {
  font-size: 0.75em;
  padding: 0.6em 0.75em;
}
.Button_module_button__f16ab410.Button_module_vote__f16ab410 {
  padding: 0.2em;
  font-size: 2em;
  font-weight: 800;
  letter-spacing: 0.3rem;
  background-color: transparent;
  color: #ffa900;
  box-shadow: none;
  text-shadow: 1px -1px #ff4d00;
  text-transform: uppercase;
  box-shadow: none;
}
.Button_module_button__f16ab410.Button_module_vote__f16ab410:hover {
  text-shadow: 1px -1px #ffa900;
  color: #ff4d00;
}

a.Button_module_button__f16ab410 {
  text-decoration: none;
}
/* Styles for the Banner component */
.Banner_module_banner__7b8c3893 {
  display: grid;
  grid-template-columns: 2fr 4fr 3fr 1fr;
  column-gap: 1em;
  align-items: center;
  background: #390099;
  padding: 0.5em 1em;
}

.Banner_module_electionLogo__7b8c3893 img {
  max-width: 80%;
  padding: 0.75em 0.75em 0.75em 0;
  margin: 0 auto;
}

.Banner_module_completed__7b8c3893 .Banner_module_electionLogo__7b8c3893 img {
  padding: 0.75em 0.75em 0.75em 0;
}

p.Banner_module_countdownCompleted__7b8c3893 {
  text-align: center;
  font-size: 1.5em;
  font-weight: 700;
  color: #ffa900;
  padding: 0.75em 0;
  margin: 0;
}

.Banner_module_stats__7b8c3893 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 700;
  color: white;
}
.Banner_module_stats__7b8c3893 > div {
  text-align: center;
}
.Banner_module_stats__7b8c3893 .Banner_module_data__7b8c3893 {
  font-size: 1.5rem;
  font-weight: 800;
}

.Banner_module_voteButton__7b8c3893 {
  text-align: center;
}

.Banner_module_autumn__7b8c3893.Banner_module_banner__7b8c3893 {
  background: linear-gradient(to bottom, #ff4d00, #ff4d00 50%, #ffa900 50%, #ffa900);
}
.Banner_module_autumn__7b8c3893 p.Banner_module_countdownCompleted__7b8c3893 {
  font-size: 1.4em;
  color: white;
  padding: 0 0 0.9em 0;
}
.Banner_module_autumn__7b8c3893 .Banner_module_stats__7b8c3893 {
  padding-top: 0.5rem;
}
.Banner_module_autumn__7b8c3893 .Banner_module_stats__7b8c3893 .Banner_module_data__7b8c3893 {
  color: #9e0059;
}

@media screen and (max-width: 848px) {
  .Banner_module_banner__7b8c3893 {
    grid-template-columns: 3fr 2fr;
  }
  .Banner_module_electionLogo__7b8c3893 {
    grid-area: 1/1/span 1/span 1;
  }
  .Banner_module_electionLogo__7b8c3893 img {
    padding-bottom: 0;
  }
  .Banner_module_countdown__7b8c3893 {
    grid-area: 2/1/span 1/span 2;
  }
  .Banner_module_stats__7b8c3893 {
    justify-content: space-evenly;
    grid-area: 3/1/span 1/span 2;
  }
  .Banner_module_voteButton__7b8c3893 {
    grid-area: 1/2/span 1/span 1;
  }
  .Banner_module_completed__7b8c3893 .Banner_module_electionLogo__7b8c3893 {
    grid-area: 1/1/span 1/span 2;
    text-align: center;
  }
  .Banner_module_completed__7b8c3893 .Banner_module_electionLogo__7b8c3893 img {
    padding: 0.75 0 0 0;
  }
  p.Banner_module_countdownCompleted__7b8c3893 {
    padding: 0.7em 0;
  }
  .Banner_module_autumn__7b8c3893.Banner_module_banner__7b8c3893 {
    grid-template-columns: 3fr 1fr;
    grid-template-rows: 3fr 4fr 4fr;
    background: linear-gradient(to bottom, #ff4d00, #ff4d00 33%, #ffa900 33%, #ffa900);
  }
  .Banner_module_autumn__7b8c3893 .Banner_module_stats__7b8c3893 {
    color: #390099;
  }
  .Banner_module_autumn__7b8c3893 .Banner_module_stats__7b8c3893 .Banner_module_data__7b8c3893 {
    color: #9e0059;
  }
  .Banner_module_autumn__7b8c3893.Banner_module_completed__7b8c3893.Banner_module_banner__7b8c3893 {
    grid-template-rows: 4fr 3fr 4fr;
    background: linear-gradient(to bottom, #ff4d00, #ff4d00 40%, #ffa900 40%, #ffa900);
  }
  .Banner_module_autumn__7b8c3893.Banner_module_completed__7b8c3893 .Banner_module_electionLogo__7b8c3893 img {
    padding: 0;
  }
  .Banner_module_autumn__7b8c3893.Banner_module_completed__7b8c3893 p.Banner_module_countdownCompleted__7b8c3893 {
    padding: 0.2em 0;
    color: #390099;
  }
}
/* Styles for the le2022 Logo component */
.Logo_module_container__dbfd7808 {
  background: linear-gradient(0deg, #390099 50%, #38808a 50%);
}
.Logo_module_container__dbfd7808 a {
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
}
.Logo_module_container__dbfd7808 a img {
  margin-top: -0.3em;
  margin-bottom: -0.1em;
}
/* Styles for the Panel component */
.Panel_module_panel__ee004986 {
  border: 1px solid #444;
  display: flex;
  flex-direction: column;
  height: calc(100% - 2px);
}
.Panel_module_panel__ee004986 > h2 {
  flex: 0 1 1.75em;
  margin: 0;
  padding: 0.125em 0.5em;
  background-color: #444;
  color: #fff;
  font-size: 1.125em;
  height: 1.5em;
  line-height: 1.5em;
}
.Panel_module_panel__ee004986 > .Panel_module_children__ee004986 {
  flex: 1 0 auto;
}
.Panel_module_panel__ee004986.Panel_module_indigo__ee004986 {
  border: 1px solid #390099;
}
.Panel_module_panel__ee004986.Panel_module_indigo__ee004986 > h2 {
  background-color: #390099;
}
.Panel_module_panel__ee004986.Panel_module_teal__ee004986 {
  border: 1px solid #38808a;
}
.Panel_module_panel__ee004986.Panel_module_teal__ee004986 > h2 {
  background-color: #38808a;
}
/* Styles for the Panel component */
.CountdownContainer_module_countdownContainer__8236de2c {
  display: grid;
  grid-template-columns: 3fr 1fr;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
}
.CountdownContainer_module_countdownContainer__8236de2c.CountdownContainer_module_completed__8236de2c {
  grid-template-columns: 1fr;
}

p.CountdownContainer_module_countdownCompleted__8236de2c {
  text-align: center;
  font-size: 2em;
  font-weight: 700;
  color: #ffa900;
  padding: 0;
  margin: 0;
}
/* Styles for the StudyType component */
.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a {
  text-align: right;
  font-size: 0.6em;
}
.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a dl {
  margin: 0.25em 1em;
}
.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a dl dd {
  display: inline;
  margin: 0;
}
.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a dl dd::before {
  display: inline-block;
  content: " ";
  vertical-align: baseline;
  width: 0.9em;
  height: 0.9em;
  border-radius: 0.45em;
  margin-left: 0.75em;
  margin-right: 0.25em;
}
.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a dl dd.RecentActivity_module_votes__5759898a::before {
  background-color: #390099;
}
.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a dl dd.RecentActivity_module_voters__5759898a::before {
  background-color: #ff005c;
}
.RecentActivity_module_container__5759898a svg .axis line {
  stroke-width: 0.21em;
  shape-rendering: crispEdges;
}
.RecentActivity_module_container__5759898a svg .axis .minor line {
  stroke: #888;
  stroke-width: 0.14em;
}
.RecentActivity_module_container__5759898a svg .axis path {
  display: none;
}
/* Styles for the StudyType component */
.StudyType_module_studyType__62789536 {
  display: flex;
  width: 100%;
}
.StudyType_module_studyType__62789536 .StudyType_module_barContainer__62789536 {
  width: 80%;
  background-color: white;
  margin: 0 0.5em 0.5em;
}
.StudyType_module_studyType__62789536 .StudyType_module_barContainer__62789536 .StudyType_module_bar__62789536 {
  width: 0;
  height: 100%;
  background-color: #ffa900;
  transition: width 0.75s ease;
}
.StudyType_module_studyType__62789536 .StudyType_module_label__62789536 {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 20%;
  margin: -0.25em 0 0.5em;
  font-size: 0.9em;
  font-weight: 800;
}
/* Styles for the StudyTypes component */
.StudyTypes_module_container__06fe834f {
  background-color: #390099;
  display: flex;
  justify-content: space-around;
  height: 100%;
  color: white;
}

@media screen and (max-width: 1140px) and (orientation: portrait) {
  .StudyTypes_module_container__06fe834f {
    flex-direction: column;
  }
}
/* Styles for the TimeLineEntry component */
.TimeLineEntry_module_timeLineEntry__59e1e3ba {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em 0.125em;
  text-align: center;
  transition: background-color 2s ease-in-out, color 2s ease-in-out, box-shadow 2s ease-in-out;
}
.TimeLineEntry_module_timeLineEntry__59e1e3ba .TimeLineEntry_module_intervalLabel__59e1e3ba {
  font-size: 0.875em;
}
.TimeLineEntry_module_timeLineEntry__59e1e3ba .TimeLineEntry_module_countContainer__59e1e3ba {
  line-height: 0.9em;
}
.TimeLineEntry_module_timeLineEntry__59e1e3ba .TimeLineEntry_module_count__59e1e3ba {
  font-size: 1.125em;
  font-weight: 700;
}
.TimeLineEntry_module_timeLineEntry__59e1e3ba .TimeLineEntry_module_countLabel__59e1e3ba {
  font-size: 0.625em;
  font-weight: 700;
}

.TimeLineEntry_module_rising__59e1e3ba, .TimeLineEntry_module_falling__59e1e3ba {
  transition: none;
}

.TimeLineEntry_module_rising__59e1e3ba {
  background-color: #ffa900;
  color: #390099;
  box-shadow: 0 0 0.1em 0.05em #ffa900;
}

.TimeLineEntry_module_falling__59e1e3ba {
  background-color: #ff005c;
  box-shadow: 0 0 0.1em 0.05em #ff005c;
  color: #ffa900;
}
/* Styles for the TimeLine component */
.TimeLine_module_container__6059004b {
  display: grid;
  grid-template-columns: 3fr 5fr 5fr 5fr;
  column-gap: 0.75em;
  align-items: center;
  padding: 0 0.75em 0 0.55em;
  background-color: #38808a;
  color: white;
  height: 100%;
}
.TimeLine_module_container__6059004b h2 {
  color: white;
  font-size: 1.125em;
}

@media screen and (max-width: 1140px) and (orientation: portrait) {
  .TimeLine_module_container__6059004b {
    height: 4.35em;
  }
}
/* Styles for the TotalStats component */
.TotalStats_module_totalStat__ef818f01 {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  align-content: center;
  align-items: center;
  height: 100%;
  color: #390099;
}
.TotalStats_module_totalStat__ef818f01 .TotalStats_module_percentage__ef818f01 {
  font-size: 3em;
  font-weight: 800;
}
.TotalStats_module_totalStat__ef818f01 .TotalStats_module_countContainer__ef818f01 {
  font-size: 1.5em;
  font-weight: 700;
}
.TotalStats_module_totalStat__ef818f01.TotalStats_module_cspStat__ef818f01 {
  color: #38808a;
}
.TotalStats_module_totalStat__ef818f01 .TotalStats_module_connectionStatus__ef818f01 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0.2em;
  height: 0.2em;
  z-index: 1;
}
.TotalStats_module_totalStat__ef818f01 .TotalStats_module_connectionStatus__ef818f01.TotalStats_module_disconnected__ef818f01 {
  background-color: #ff005c;
}
.TotalStats_module_totalStat__ef818f01 .TotalStats_module_connectionStatus__ef818f01.TotalStats_module_connected__ef818f01 {
  background-color: green;
}
/* Styles for the StudyType component */
.ConstituentUnion_module_cus__68c20bd0 {
  display: flex;
  align-items: center;
  padding: 0.1em 0;
}
.ConstituentUnion_module_cus__68c20bd0:nth-child(1) {
  -ms-transform: translate(0, 0%);
  -webkit-transform: translate3d(0, 0%, 0);
  transform: translate3d(0, 0%, 0);
}
.ConstituentUnion_module_cus__68c20bd0::before {
  display: inline-block;
  content: counter(item);
  counter-increment: item;
  color: #390099;
  background-color: #ffa900;
  width: 1.325em;
  height: 1.3em;
  line-height: 1.3;
  border-radius: 0.64em;
  text-align: center;
  font-size: 1.2em;
  font-weight: 700;
}
.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_content__68c20bd0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 1.2em);
}
.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_barcontainer__68c20bd0 {
  flex: 1 0 auto;
  position: relative;
  height: 1.25em;
  vertical-align: middle;
  margin-left: -0.9em;
  z-index: -1;
  background: none;
}
.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_barcontainer__68c20bd0 .ConstituentUnion_module_bar__68c20bd0 {
  position: absolute;
  box-sizing: content-box;
  background-color: #92ced3;
  border-radius: 0;
  width: 0;
  height: 1.25em;
  padding-left: 0.9em;
  -webkit-transition: width 1s ease;
  transition: width 1s ease;
}
.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_barcontainer__68c20bd0 .ConstituentUnion_module_info__68c20bd0 {
  margin-left: 1.5em;
  text-align: left;
  position: relative;
  z-index: 3;
  padding-right: 0.25em;
  font-size: 0.75em;
}
.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_barcontainer__68c20bd0 .ConstituentUnion_module_info__68c20bd0 .ConstituentUnion_module_label__68c20bd0 {
  vertical-align: middle;
  font-weight: 700;
  color: #390099;
}
.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_percentage__68c20bd0 {
  flex: 0 1 3.5em;
  padding-right: 5px;
  text-align: right;
  font-size: 1em;
  font-weight: 700;
  color: #390099;
  vertical-align: middle;
}
.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_icon__68c20bd0 {
  flex: 0 1 auto;
  height: 1.8em;
  width: 1.8em;
}
/* Styles for the StudyType component */
.ConstituentUnions_module_container__083a9e87 {
  height: 100%;
  overflow: hidden;
}

ol.ConstituentUnions_module_list__083a9e87 {
  counter-reset: item;
  -webkit-transition: top 0.5s ease-out;
  transition: top 0.5s ease-out;
  margin-left: 0;
  margin: 0;
  padding: 0.5em 0.5em 0;
}
/* Styles for the TopTurnoutList component */
.TopTurnoutEntry_module_entry__d3f8bcf4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.1em 0;
}
.TopTurnoutEntry_module_entry__d3f8bcf4::before {
  flex: 0 1 auto;
  display: inline-block;
  content: counter(item);
  counter-increment: item;
  color: #390099;
  background-color: #ffa900;
  width: 1.3em;
  height: 1.3em;
  line-height: 1.3;
  border-radius: 0.65em;
  text-align: center;
  font-size: 1.2em;
  font-weight: 700;
}
.TopTurnoutEntry_module_entry__d3f8bcf4:nth-child(n+10):nth-child(-n+99)::before {
  font-size: 1em;
  width: 1.56em;
  height: 1.56em;
  border-radius: 0.78em;
  line-height: 1.56;
}
.TopTurnoutEntry_module_entry__d3f8bcf4:nth-child(n+100)::before {
  font-size: 0.75em;
  width: 2.08em;
  height: 2.08em;
  border-radius: 1.04em;
  line-height: 2.08;
}
.TopTurnoutEntry_module_entry__d3f8bcf4 .TopTurnoutEntry_module_label__d3f8bcf4 {
  flex: 1 0 auto;
  margin-left: 0.5em;
  text-align: left;
  font-weight: 700;
  font-size: 0.75em;
  line-height: 1em;
  max-width: 80%;
  color: #390099;
}
.TopTurnoutEntry_module_entry__d3f8bcf4 .TopTurnoutEntry_module_percentage__d3f8bcf4 {
  flex: 0 1 auto;
  padding-right: 5px;
  text-align: right;
  font-size: 1em;
  font-weight: 700;
  color: #390099;
  vertical-align: middle;
}
/* Styles for the TopTurnoutList component */
.TopTurnoutList_module_container__29035d8e {
  font-size: 1em;
}

ol.TopTurnoutList_module_entrylist__29035d8e {
  counter-reset: item;
  -webkit-transition: top 0.5s ease-out;
  transition: top 0.5s ease-out;
  margin: 0 0 0.5em;
  padding: 0.5em;
  height: 7.5em;
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-color: #92ced3 #dbeff0;
  scrollbar-width: thin;
}
ol.TopTurnoutList_module_entrylist__29035d8e::-webkit-scrollbar-thumb {
  background-color: #92ced3;
}
ol.TopTurnoutList_module_entrylist__29035d8e::-webkit-scrollbar-track {
  background-color: #dbeff0;
}
ol.TopTurnoutList_module_entrylist__29035d8e::-webkit-scrollbar-corner {
  background-color: #dbeff0;
}
ol.TopTurnoutList_module_entrylist__29035d8e::-webkit-scrollbar {
  width: 0.5rem;
}
/* Styles for the ElectionProgress component */
.ElectionProgress_module_container__aeb63221 {
  position: relative;
  height: 100%;
  padding: 0 0.5em;
  overflow: hidden;
  background-color: #390099;
  color: white;
  z-index: 1;
}

@media screen and (max-width: 1140px) and (orientation: portrait) {
  .ElectionProgress_module_container__aeb63221 {
    height: 5em;
  }
}
ul.ElectionProgress_module_markers__aeb63221 {
  margin: 0;
  padding: 1.25em 2em 0 0.75em;
  list-style: none;
}
ul.ElectionProgress_module_markers__aeb63221 li {
  position: absolute;
  display: block;
  z-index: 2;
  transition: width 0.75s ease;
}
ul.ElectionProgress_module_markers__aeb63221 li span {
  position: absolute;
  top: 0.3em;
  right: 0.3em;
  font-size: 0.7em;
  font-weight: 700;
  writing-mode: vertical-rl;
}
ul.ElectionProgress_module_markers__aeb63221 li[data-tooltip]:not([data-tooltip=""]) span {
  text-decoration: underline dotted;
}
ul.ElectionProgress_module_markers__aeb63221 li[data-tooltip]:not([data-tooltip=""]):hover::before, ul.ElectionProgress_module_markers__aeb63221 li[data-tooltip]:not([data-tooltip=""]):focus::before, ul.ElectionProgress_module_markers__aeb63221 li[data-tooltip]:not([data-tooltip=""]):active::before {
  content: attr(data-tooltip);
  display: block;
  position: absolute;
  z-index: 3;
  top: 0.5em;
  right: 2em;
  background-color: white;
  color: black;
  border: 1px solid #888;
  padding: 0.5em;
  font-size: 0.6em;
}
ul.ElectionProgress_module_markers__aeb63221 li::after {
  content: " ";
  position: absolute;
  top: -0.25em;
  right: 0;
  width: 0.2em;
  height: 2.75em;
  background-color: white;
}
ul.ElectionProgress_module_markers__aeb63221 li.ElectionProgress_module_tick__aeb63221 span {
  top: -1.75em;
  right: -1em;
  writing-mode: horizontal-tb;
}
ul.ElectionProgress_module_markers__aeb63221 li.ElectionProgress_module_tick__aeb63221::after {
  width: 0.1em;
  background-color: rgba(255, 255, 255, 0.75);
}

.ElectionProgress_module_currentYear__aeb63221 {
  position: absolute;
  left: 0.75em;
  display: block;
  height: 2em;
  padding-left: 0.5em;
  background-color: #ffa900;
  box-shadow: -0.2em 0.2em 0 0 #ff005c;
  transition: width 2s cubic-bezier(0.5, 1, 0.89, 1);
}
/* Styles for the Milestone component */
.Milestone_module_container__36efb943 {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #9e0059;
  color: white;
  transition: none;
}
.Milestone_module_container__36efb943.Milestone_module_finished__36efb943 {
  background-color: #390099;
  color: #390099;
  transition: all 1s ease-out;
}

.Milestone_module_loadEffect__36efb943 {
  transition: none;
  transform: scale(0.1);
}
.Milestone_module_loadEffect__36efb943.Milestone_module_loaded__36efb943 {
  transition: all 1s ease-out;
  transform: scale(1);
}

.Milestone_module_message__36efb943 {
  font-size: 1.5em;
  font-weight: 600;
}
/* Styles for the Dashboard component */
.Dashboard_module_dashboard__2db5910f {
  display: grid;
  aspect-ratio: 16/9;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1.45fr 1.05fr 3fr 1.5fr;
  gap: 1px;
  font-size: calc(8px + 8 * (100vw - 585px) / 585);
}
.Dashboard_module_dashboard__2db5910f.Dashboard_module_maxWidth1170__2db5910f {
  max-width: 1170px;
  font-size: clamp(8px, 16px, 8px + 8 * (100vw - 585px) / 585);
}

.Dashboard_module_grid__2db5910f {
  height: 100%;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_votingCloses__2db5910f, .Dashboard_module_grid__2db5910f.Dashboard_module_milestone__2db5910f {
  grid-column: 2/span 6;
  grid-row: 1/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_logo__2db5910f {
  grid-column: 1/span 1;
  grid-row: 1/span 2;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_totalMain__2db5910f {
  grid-column: 2/span 3;
  grid-row: 3/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_totalCSPs__2db5910f {
  grid-column: 5/span 3;
  grid-row: 3/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_recentActivity__2db5910f {
  grid-column: 1/span 1;
  grid-row: 3/span 2;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_studyTypes__2db5910f {
  grid-column: 2/span 6;
  grid-row: 4/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_sourceToggle__2db5910f {
  grid-column: 7/span 1;
  grid-row: 2/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_timeLine__2db5910f {
  grid-column: 2/span 5;
  grid-row: 2/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_CUs__2db5910f {
  grid-column: 1/span 1;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_depts__2db5910f {
  grid-column: 2/span 2;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_CSPs__2db5910f {
  grid-column: 4/span 2;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_halls__2db5910f {
  grid-column: 6/span 2;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_progress__2db5910f {
  grid-column: 1/span 7;
  grid-row: 6/span 1;
}

.Dashboard_module_sourceToggle__2db5910f {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  padding: 0.5em;
  height: calc(100% - 1em);
}
.Dashboard_module_sourceToggle__2db5910f > span {
  font-size: 0.7em;
}

.Dashboard_module_votingCloses__2db5910f {
  background-color: #390099;
}

.Dashboard_module_loader__2db5910f {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

@media screen and (max-width: 1140px) and (orientation: portrait) {
  .Dashboard_module_dashboard__2db5910f {
    display: grid;
    aspect-ratio: initial;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    gap: 1px;
    font-size: calc(8px + 8 * (100vw - 360px) / 360);
  }
  .Dashboard_module_dashboard__2db5910f.Dashboard_module_maxWidth1170__2db5910f {
    font-size: calc(8px + 8 * (100vw - 360px) / 360);
  }
  .Dashboard_module_grid__2db5910f {
    height: auto;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_votingCloses__2db5910f, .Dashboard_module_grid__2db5910f.Dashboard_module_milestone__2db5910f {
    grid-column: 1/span 2;
    grid-row: 2/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_logo__2db5910f {
    grid-column: 1/span 2;
    grid-row: 1/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_totalMain__2db5910f {
    grid-column: 1/span 1;
    grid-row: 3/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_totalCSPs__2db5910f {
    grid-column: 2/span 1;
    grid-row: 3/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_recentActivity__2db5910f {
    grid-column: 1/span 1;
    grid-row: 5/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_studyTypes__2db5910f {
    grid-column: 2/span 1;
    grid-row: 5/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_sourceToggle__2db5910f {
    grid-column: 1/span 2;
    grid-row: 6/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_timeLine__2db5910f {
    grid-column: 1/span 2;
    grid-row: 4/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_CUs__2db5910f {
    grid-column: 1/span 1;
    grid-row: 7/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_depts__2db5910f {
    grid-column: 2/span 1;
    grid-row: 7/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_CSPs__2db5910f {
    grid-column: 1/span 1;
    grid-row: 8/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_halls__2db5910f {
    grid-column: 2/span 1;
    grid-row: 8/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_progress__2db5910f {
    grid-column: 1/span 2;
    grid-row: 9/span 1;
  }
  .Dashboard_module_sourceToggle__2db5910f {
    height: 3.25em;
  }
}
.RollingTimeFrame_module_container__f1acef40 {
  display: flex;
  justify-content: center;
  column-gap: 0.3em;
  margin: 0.5em 0;
  box-sizing: border-box;
}
.RollingTimeFrame_module_container__f1acef40 .RollingTimeFrame_module_btn__f1acef40 {
  font-size: 0.75em;
  font-weight: 800;
  background-color: transparent;
  color: #38808a;
  box-shadow: none;
  padding: 0.5em 0.55em;
  border: 1px solid #ffa900;
  vertical-align: middle;
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
  width: 21.5%;
  line-height: 1;
}
.RollingTimeFrame_module_container__f1acef40 .RollingTimeFrame_module_btn__f1acef40:hover {
  background-color: #ffa900;
  border-color: #ffa900;
  color: #38808a;
}
.RollingTimeFrame_module_container__f1acef40 .RollingTimeFrame_module_active__f1acef40 {
  font-size: 0.75em;
  font-weight: 800;
  background-color: #ffa900;
  padding: 0.5em 0.55em;
  border: 1px solid #ffa900;
  color: #38808a;
  width: 21.5%;
  line-height: 1;
}
/* Styles for the Dashboard component */
.StepByStep_module_stepContainer__2745d666 {
  max-width: 1170px;
  text-align: center;
}
.StepByStep_module_stepContainer__2745d666 .StepByStep_module_paragraph__2745d666 {
  margin: 2em;
}
/* Styles for the le2023 Logo component */
.Logo_module_container__a4a750ff {
  background: linear-gradient(0deg, #390099 50%, #38808a 50%);
}
.Logo_module_container__a4a750ff a {
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
}
.Logo_module_container__a4a750ff a img {
  margin-top: 0.45em;
  margin-bottom: -0.1em;
}
/* Styles for the Dashboard component */
.Dashboard_module_dashboard__2db5910f {
  display: grid;
  aspect-ratio: 16/9;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1.45fr 1.05fr 3fr 1.5fr;
  gap: 1px;
  font-size: calc(8px + 8 * (100vw - 585px) / 585);
}
.Dashboard_module_dashboard__2db5910f.Dashboard_module_maxWidth1170__2db5910f {
  max-width: 1170px;
  font-size: clamp(8px, 16px, 8px + 8 * (100vw - 585px) / 585);
}

.Dashboard_module_grid__2db5910f {
  height: 100%;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_votingCloses__2db5910f, .Dashboard_module_grid__2db5910f.Dashboard_module_milestone__2db5910f {
  grid-column: 2/span 6;
  grid-row: 1/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_logo__2db5910f {
  grid-column: 1/span 1;
  grid-row: 1/span 2;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_totalMain__2db5910f {
  grid-column: 2/span 3;
  grid-row: 3/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_totalCSPs__2db5910f {
  grid-column: 5/span 3;
  grid-row: 3/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_recentActivity__2db5910f {
  grid-column: 1/span 1;
  grid-row: 3/span 2;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_studyTypes__2db5910f {
  grid-column: 2/span 6;
  grid-row: 4/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_sourceToggle__2db5910f {
  grid-column: 7/span 1;
  grid-row: 2/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_timeLine__2db5910f {
  grid-column: 2/span 5;
  grid-row: 2/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_CUs__2db5910f {
  grid-column: 1/span 1;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_depts__2db5910f {
  grid-column: 2/span 2;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_CSPs__2db5910f {
  grid-column: 4/span 2;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_halls__2db5910f {
  grid-column: 6/span 2;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__2db5910f.Dashboard_module_progress__2db5910f {
  grid-column: 1/span 7;
  grid-row: 6/span 1;
}

.Dashboard_module_sourceToggle__2db5910f {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  padding: 0.5em;
  height: calc(100% - 1em);
}
.Dashboard_module_sourceToggle__2db5910f > span {
  font-size: 0.7em;
}

.Dashboard_module_votingCloses__2db5910f {
  background-color: #390099;
}

.Dashboard_module_loader__2db5910f {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

@media screen and (max-width: 1140px) and (orientation: portrait) {
  .Dashboard_module_dashboard__2db5910f {
    display: grid;
    aspect-ratio: initial;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    gap: 1px;
    font-size: calc(8px + 8 * (100vw - 360px) / 360);
  }
  .Dashboard_module_dashboard__2db5910f.Dashboard_module_maxWidth1170__2db5910f {
    font-size: calc(8px + 8 * (100vw - 360px) / 360);
  }
  .Dashboard_module_grid__2db5910f {
    height: auto;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_votingCloses__2db5910f, .Dashboard_module_grid__2db5910f.Dashboard_module_milestone__2db5910f {
    grid-column: 1/span 2;
    grid-row: 2/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_logo__2db5910f {
    grid-column: 1/span 2;
    grid-row: 1/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_totalMain__2db5910f {
    grid-column: 1/span 1;
    grid-row: 3/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_totalCSPs__2db5910f {
    grid-column: 2/span 1;
    grid-row: 3/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_recentActivity__2db5910f {
    grid-column: 1/span 1;
    grid-row: 5/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_studyTypes__2db5910f {
    grid-column: 2/span 1;
    grid-row: 5/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_sourceToggle__2db5910f {
    grid-column: 1/span 2;
    grid-row: 6/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_timeLine__2db5910f {
    grid-column: 1/span 2;
    grid-row: 4/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_CUs__2db5910f {
    grid-column: 1/span 1;
    grid-row: 7/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_depts__2db5910f {
    grid-column: 2/span 1;
    grid-row: 7/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_CSPs__2db5910f {
    grid-column: 1/span 1;
    grid-row: 8/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_halls__2db5910f {
    grid-column: 2/span 1;
    grid-row: 8/span 1;
  }
  .Dashboard_module_grid__2db5910f.Dashboard_module_progress__2db5910f {
    grid-column: 1/span 2;
    grid-row: 9/span 1;
  }
  .Dashboard_module_sourceToggle__2db5910f {
    height: 3.25em;
  }
}
/* Styles for the Dashboard component */
.StepByStep_module_stepContainer__2745d666 {
  max-width: 1170px;
  text-align: center;
}
.StepByStep_module_stepContainer__2745d666 .StepByStep_module_paragraph__2745d666 {
  margin: 2em;
}
/* Styles for the le2024 Logo component */
.Logo_module_container__d3dc2f40 {
  background: linear-gradient(0deg, #390099 50%, #38808a 50%);
  height: 100%;
}
.Logo_module_container__d3dc2f40 a {
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
}
.Logo_module_container__d3dc2f40 a img {
  margin-top: 1.46em;
  margin-bottom: -0.1em;
}
/* Styles for the Dashboard component */
.Dashboard_module_dashboard__bd53cb77 {
  display: grid;
  aspect-ratio: 16/9;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1.45fr 1.05fr 3fr 1.5fr;
  gap: 1px;
  font-size: calc(8px + 8 * (100vw - 585px) / 585);
}
.Dashboard_module_dashboard__bd53cb77.Dashboard_module_maxWidth1170__bd53cb77 {
  max-width: 1170px;
  font-size: clamp(8px, 16px, 8px + 8 * (100vw - 585px) / 585);
}

.Dashboard_module_grid__bd53cb77 {
  height: 100%;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_votingCloses__bd53cb77, .Dashboard_module_grid__bd53cb77.Dashboard_module_milestone__bd53cb77 {
  grid-column: 2/span 6;
  grid-row: 1/span 1;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_logo__bd53cb77 {
  grid-column: 1/span 1;
  grid-row: 1/span 2;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_totalMain__bd53cb77 {
  grid-column: 2/span 3;
  grid-row: 3/span 1;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_totalCSPs__bd53cb77 {
  grid-column: 5/span 3;
  grid-row: 3/span 1;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_recentActivity__bd53cb77 {
  grid-column: 1/span 1;
  grid-row: 3/span 2;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_studyTypes__bd53cb77 {
  grid-column: 2/span 6;
  grid-row: 4/span 1;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_sourceToggle__bd53cb77 {
  grid-column: 7/span 1;
  grid-row: 2/span 1;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_timeLine__bd53cb77 {
  grid-column: 2/span 5;
  grid-row: 2/span 1;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_CUs__bd53cb77 {
  grid-column: 1/span 1;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_depts__bd53cb77 {
  grid-column: 2/span 2;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_CSPs__bd53cb77 {
  grid-column: 4/span 2;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_halls__bd53cb77 {
  grid-column: 6/span 2;
  grid-row: 5/span 1;
}
.Dashboard_module_grid__bd53cb77.Dashboard_module_progress__bd53cb77 {
  grid-column: 1/span 7;
  grid-row: 6/span 1;
}

.Dashboard_module_sourceToggle__bd53cb77 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  padding: 0.5em;
  height: calc(100% - 1em);
}
.Dashboard_module_sourceToggle__bd53cb77 > span {
  font-size: 0.7em;
}

.Dashboard_module_votingCloses__bd53cb77 {
  background-color: #390099;
}

.Dashboard_module_loader__bd53cb77 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

@media screen and (max-width: 1140px) and (orientation: portrait) {
  .Dashboard_module_dashboard__bd53cb77 {
    display: grid;
    aspect-ratio: initial;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    gap: 1px;
    font-size: calc(8px + 8 * (100vw - 360px) / 360);
  }
  .Dashboard_module_dashboard__bd53cb77.Dashboard_module_maxWidth1170__bd53cb77 {
    font-size: calc(8px + 8 * (100vw - 360px) / 360);
  }
  .Dashboard_module_grid__bd53cb77 {
    height: auto;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_votingCloses__bd53cb77, .Dashboard_module_grid__bd53cb77.Dashboard_module_milestone__bd53cb77 {
    grid-column: 1/span 2;
    grid-row: 2/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_logo__bd53cb77 {
    grid-column: 1/span 2;
    grid-row: 1/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_totalMain__bd53cb77 {
    grid-column: 1/span 1;
    grid-row: 3/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_totalCSPs__bd53cb77 {
    grid-column: 2/span 1;
    grid-row: 3/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_recentActivity__bd53cb77 {
    grid-column: 1/span 1;
    grid-row: 5/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_studyTypes__bd53cb77 {
    grid-column: 2/span 1;
    grid-row: 5/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_sourceToggle__bd53cb77 {
    grid-column: 1/span 2;
    grid-row: 9/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_timeLine__bd53cb77 {
    grid-column: 1/span 2;
    grid-row: 4/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_CUs__bd53cb77 {
    grid-column: 1/span 1;
    grid-row: 6/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_depts__bd53cb77 {
    grid-column: 2/span 1;
    grid-row: 6/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_CSPs__bd53cb77 {
    grid-column: 1/span 1;
    grid-row: 7/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_halls__bd53cb77 {
    grid-column: 2/span 1;
    grid-row: 7/span 1;
  }
  .Dashboard_module_grid__bd53cb77.Dashboard_module_progress__bd53cb77 {
    grid-column: 1/span 2;
    grid-row: 8/span 1;
  }
  .Dashboard_module_sourceToggle__bd53cb77 {
    font-size: 1.25em;
    flex-direction: row;
    height: 2em;
  }
  .Dashboard_module_sourceToggle__bd53cb77 span[data-tooltip]:not([data-tooltip=""]):hover::before, .Dashboard_module_sourceToggle__bd53cb77 span[data-tooltip]:not([data-tooltip=""]):focus::before, .Dashboard_module_sourceToggle__bd53cb77 span[data-tooltip]:not([data-tooltip=""]):active::before {
    top: initial;
    right: initial;
    bottom: 0.5em;
    left: 3em;
  }
}
/* Styles for the Dashboard component */
.StepByStep_module_stepContainer__2745d666 {
  max-width: 1170px;
  text-align: center;
}
.StepByStep_module_stepContainer__2745d666 .StepByStep_module_paragraph__2745d666 {
  margin: 2em;
}`, "",{"version":3,"sources":["webpack://./node_modules/election-stats-icu/dist/index.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,2CAA2C;AAC7C;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA,wCAAwC;AACxC;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;AACF;AACA,oCAAoC;AACpC;EACE,qBAAqB;EACrB,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;EACtB,iEAAiE;EACjE,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;AACA,oCAAoC;AACpC;EACE,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kFAAkF;AACpF;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,kFAAkF;EACpF;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,+BAA+B;IAC/B,kFAAkF;EACpF;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;AACA,yCAAyC;AACzC;EACE,2DAA2D;AAC7D;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,mCAAmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,SAAS;AACX;AACA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA,uCAAuC;AACvC;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;AACA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,4FAA4F;AAC9F;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;AAChB;AACA,sCAAsC;AACtC;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;AACA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;EACb,YAAY;AACd;AACA,uCAAuC;AACvC;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;AACA,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,kDAAkD;AACpD;AACA,uCAAuC;AACvC;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA,uCAAuC;AACvC;EACE,aAAa;EACb,kBAAkB;EAClB,kDAAkD;EAClD,mDAAmD;EACnD,QAAQ;EACR,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,4DAA4D;AAC9D;;AAEA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,wBAAwB;IACxB,QAAQ;IACR,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,iEAAiE;EACjE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;AACA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA,yCAAyC;AACzC;EACE,2DAA2D;AAC7D;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA,uCAAuC;AACvC;EACE,aAAa;EACb,kBAAkB;EAClB,kDAAkD;EAClD,mDAAmD;EACnD,QAAQ;EACR,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,4DAA4D;AAC9D;;AAEA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,wBAAwB;IACxB,QAAQ;IACR,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;AACF;AACA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA,yCAAyC;AACzC;EACE,2DAA2D;EAC3D,YAAY;AACd;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA,uCAAuC;AACvC;EACE,aAAa;EACb,kBAAkB;EAClB,kDAAkD;EAClD,mDAAmD;EACnD,QAAQ;EACR,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,4DAA4D;AAC9D;;AAEA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,wBAAwB;IACxB,QAAQ;IACR,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,YAAY;IACZ,cAAc;IACd,aAAa;IACb,SAAS;EACX;AACF;AACA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb","sourcesContent":["/* Styles common to all components. */\n.election-stats-icu {\n  box-sizing: content-box;\n  font-family: \"Open Sans\", Arial, sans-serif;\n}\n.election-stats-icu p {\n  margin-bottom: 1rem;\n  font-size: inherit;\n  line-height: 1.6;\n  text-rendering: optimizeLegibility;\n}\n.election-stats-icu h1, .election-stats-icu h2, .election-stats-icu h3, .election-stats-icu h4, .election-stats-icu h5, .election-stats-icu h6 {\n  margin: 0;\n  padding: 0;\n  font-weight: 700;\n  letter-spacing: normal;\n}\n.election-stats-icu h1::after, .election-stats-icu h2::after, .election-stats-icu h3::after, .election-stats-icu h4::after, .election-stats-icu h5::after, .election-stats-icu h6::after {\n  display: none;\n}\n.election-stats-icu span[data-tooltip]:not([data-tooltip=\"\"]) {\n  position: relative;\n  text-decoration: underline dotted;\n}\n.election-stats-icu span[data-tooltip]:not([data-tooltip=\"\"]):hover::before, .election-stats-icu span[data-tooltip]:not([data-tooltip=\"\"]):focus::before, .election-stats-icu span[data-tooltip]:not([data-tooltip=\"\"]):active::before {\n  content: attr(data-tooltip);\n  display: block;\n  position: absolute;\n  z-index: 3;\n  top: 0.5em;\n  right: 3em;\n  width: 20em;\n  line-height: 1.2;\n  background-color: white;\n  color: black;\n  border: 1px solid #888;\n  padding: 0.5em;\n  font-size: 1em;\n  font-weight: 400;\n}\n.election-stats-icu h2 span[data-tooltip]:not([data-tooltip=\"\"]):hover::before, .election-stats-icu h2 span[data-tooltip]:not([data-tooltip=\"\"]):focus::before, .election-stats-icu h2 span[data-tooltip]:not([data-tooltip=\"\"]):active::before {\n  font-size: 0.5em;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.show-for-sr {\n  position: absolute !important;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n/* ElectionCountdown component styles. */\n.ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_timeRow__c8f4e638 {\n  display: flex;\n  text-align: center;\n  justify-content: space-around;\n  align-items: center;\n  color: white;\n}\n.ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_header__c8f4e638 {\n  max-width: 17%;\n  margin-bottom: 0;\n  color: #ffa900;\n  font-size: 0.75em;\n  font-weight: 700;\n}\n.ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_time__c8f4e638 {\n  text-align: center;\n}\n.ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_time__c8f4e638 .ElectionCountdown_module_count__c8f4e638 {\n  padding: 0 0.5em;\n  font-size: 1.8em;\n  font-weight: 800;\n}\n.ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_time__c8f4e638 .ElectionCountdown_module_label__c8f4e638 {\n  font-size: 0.8em;\n  font-weight: 700;\n}\n.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_dashboardCountdown__c8f4e638 .ElectionCountdown_module_timeRow__c8f4e638 {\n  justify-content: space-between;\n  padding: 0 0.75em 0 0.55em;\n}\n.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_dashboardCountdown__c8f4e638 .ElectionCountdown_module_header__c8f4e638 {\n  max-width: 100%;\n  font-size: 1.125em;\n  margin: unset;\n}\n.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 {\n  padding-bottom: 1em;\n}\n.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 .ElectionCountdown_module_timeRow__c8f4e638 {\n  color: #390099;\n}\n.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 .ElectionCountdown_module_header__c8f4e638 {\n  color: #390099;\n}\n.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 .ElectionCountdown_module_time__c8f4e638 {\n  display: flex;\n  flex-direction: column;\n}\n.ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 .ElectionCountdown_module_time__c8f4e638 .ElectionCountdown_module_count__c8f4e638 {\n  color: white;\n}\n\n@media screen and (max-width: 848px) {\n  .ElectionCountdown_module_countdown__c8f4e638 {\n    margin: 0.5em 0.5em 1em;\n  }\n  .ElectionCountdown_module_countdown__c8f4e638 .ElectionCountdown_module_time__c8f4e638 {\n    display: flex;\n    flex-direction: column;\n  }\n  .ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 {\n    padding-bottom: 0;\n    margin-bottom: 0.5em;\n  }\n  .ElectionCountdown_module_countdown__c8f4e638.ElectionCountdown_module_ae2022__c8f4e638 .ElectionCountdown_module_time__c8f4e638 .ElectionCountdown_module_count__c8f4e638 {\n    color: #9e0059;\n  }\n}\n/* Styles for the Button component */\n.Button_module_button__f16ab410 {\n  display: inline-block;\n  padding: 0.75em 0.9em;\n  border: 1px solid transparent;\n  vertical-align: middle;\n  transition: background-color 0.25s ease-out, color 0.25s ease-out;\n  font-size: 0.9em;\n  font-family: inherit;\n  -webkit-appearance: none;\n  line-height: 1;\n  text-align: center;\n  cursor: pointer;\n  background-color: #390099;\n  color: #ffa900;\n  box-shadow: 0.16em 0.16em 0 0 #ff005c;\n}\n.Button_module_button__f16ab410:hover {\n  background-color: #9e0059;\n}\n.Button_module_button__f16ab410.Button_module_small__f16ab410 {\n  font-size: 0.75em;\n  padding: 0.6em 0.75em;\n}\n.Button_module_button__f16ab410.Button_module_vote__f16ab410 {\n  padding: 0.2em;\n  font-size: 2em;\n  font-weight: 800;\n  letter-spacing: 0.3rem;\n  background-color: transparent;\n  color: #ffa900;\n  box-shadow: none;\n  text-shadow: 1px -1px #ff4d00;\n  text-transform: uppercase;\n  box-shadow: none;\n}\n.Button_module_button__f16ab410.Button_module_vote__f16ab410:hover {\n  text-shadow: 1px -1px #ffa900;\n  color: #ff4d00;\n}\n\na.Button_module_button__f16ab410 {\n  text-decoration: none;\n}\n/* Styles for the Banner component */\n.Banner_module_banner__7b8c3893 {\n  display: grid;\n  grid-template-columns: 2fr 4fr 3fr 1fr;\n  column-gap: 1em;\n  align-items: center;\n  background: #390099;\n  padding: 0.5em 1em;\n}\n\n.Banner_module_electionLogo__7b8c3893 img {\n  max-width: 80%;\n  padding: 0.75em 0.75em 0.75em 0;\n  margin: 0 auto;\n}\n\n.Banner_module_completed__7b8c3893 .Banner_module_electionLogo__7b8c3893 img {\n  padding: 0.75em 0.75em 0.75em 0;\n}\n\np.Banner_module_countdownCompleted__7b8c3893 {\n  text-align: center;\n  font-size: 1.5em;\n  font-weight: 700;\n  color: #ffa900;\n  padding: 0.75em 0;\n  margin: 0;\n}\n\n.Banner_module_stats__7b8c3893 {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: white;\n}\n.Banner_module_stats__7b8c3893 > div {\n  text-align: center;\n}\n.Banner_module_stats__7b8c3893 .Banner_module_data__7b8c3893 {\n  font-size: 1.5rem;\n  font-weight: 800;\n}\n\n.Banner_module_voteButton__7b8c3893 {\n  text-align: center;\n}\n\n.Banner_module_autumn__7b8c3893.Banner_module_banner__7b8c3893 {\n  background: linear-gradient(to bottom, #ff4d00, #ff4d00 50%, #ffa900 50%, #ffa900);\n}\n.Banner_module_autumn__7b8c3893 p.Banner_module_countdownCompleted__7b8c3893 {\n  font-size: 1.4em;\n  color: white;\n  padding: 0 0 0.9em 0;\n}\n.Banner_module_autumn__7b8c3893 .Banner_module_stats__7b8c3893 {\n  padding-top: 0.5rem;\n}\n.Banner_module_autumn__7b8c3893 .Banner_module_stats__7b8c3893 .Banner_module_data__7b8c3893 {\n  color: #9e0059;\n}\n\n@media screen and (max-width: 848px) {\n  .Banner_module_banner__7b8c3893 {\n    grid-template-columns: 3fr 2fr;\n  }\n  .Banner_module_electionLogo__7b8c3893 {\n    grid-area: 1/1/span 1/span 1;\n  }\n  .Banner_module_electionLogo__7b8c3893 img {\n    padding-bottom: 0;\n  }\n  .Banner_module_countdown__7b8c3893 {\n    grid-area: 2/1/span 1/span 2;\n  }\n  .Banner_module_stats__7b8c3893 {\n    justify-content: space-evenly;\n    grid-area: 3/1/span 1/span 2;\n  }\n  .Banner_module_voteButton__7b8c3893 {\n    grid-area: 1/2/span 1/span 1;\n  }\n  .Banner_module_completed__7b8c3893 .Banner_module_electionLogo__7b8c3893 {\n    grid-area: 1/1/span 1/span 2;\n    text-align: center;\n  }\n  .Banner_module_completed__7b8c3893 .Banner_module_electionLogo__7b8c3893 img {\n    padding: 0.75 0 0 0;\n  }\n  p.Banner_module_countdownCompleted__7b8c3893 {\n    padding: 0.7em 0;\n  }\n  .Banner_module_autumn__7b8c3893.Banner_module_banner__7b8c3893 {\n    grid-template-columns: 3fr 1fr;\n    grid-template-rows: 3fr 4fr 4fr;\n    background: linear-gradient(to bottom, #ff4d00, #ff4d00 33%, #ffa900 33%, #ffa900);\n  }\n  .Banner_module_autumn__7b8c3893 .Banner_module_stats__7b8c3893 {\n    color: #390099;\n  }\n  .Banner_module_autumn__7b8c3893 .Banner_module_stats__7b8c3893 .Banner_module_data__7b8c3893 {\n    color: #9e0059;\n  }\n  .Banner_module_autumn__7b8c3893.Banner_module_completed__7b8c3893.Banner_module_banner__7b8c3893 {\n    grid-template-rows: 4fr 3fr 4fr;\n    background: linear-gradient(to bottom, #ff4d00, #ff4d00 40%, #ffa900 40%, #ffa900);\n  }\n  .Banner_module_autumn__7b8c3893.Banner_module_completed__7b8c3893 .Banner_module_electionLogo__7b8c3893 img {\n    padding: 0;\n  }\n  .Banner_module_autumn__7b8c3893.Banner_module_completed__7b8c3893 p.Banner_module_countdownCompleted__7b8c3893 {\n    padding: 0.2em 0;\n    color: #390099;\n  }\n}\n/* Styles for the le2022 Logo component */\n.Logo_module_container__dbfd7808 {\n  background: linear-gradient(0deg, #390099 50%, #38808a 50%);\n}\n.Logo_module_container__dbfd7808 a {\n  display: flex;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n.Logo_module_container__dbfd7808 a img {\n  margin-top: -0.3em;\n  margin-bottom: -0.1em;\n}\n/* Styles for the Panel component */\n.Panel_module_panel__ee004986 {\n  border: 1px solid #444;\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 2px);\n}\n.Panel_module_panel__ee004986 > h2 {\n  flex: 0 1 1.75em;\n  margin: 0;\n  padding: 0.125em 0.5em;\n  background-color: #444;\n  color: #fff;\n  font-size: 1.125em;\n  height: 1.5em;\n  line-height: 1.5em;\n}\n.Panel_module_panel__ee004986 > .Panel_module_children__ee004986 {\n  flex: 1 0 auto;\n}\n.Panel_module_panel__ee004986.Panel_module_indigo__ee004986 {\n  border: 1px solid #390099;\n}\n.Panel_module_panel__ee004986.Panel_module_indigo__ee004986 > h2 {\n  background-color: #390099;\n}\n.Panel_module_panel__ee004986.Panel_module_teal__ee004986 {\n  border: 1px solid #38808a;\n}\n.Panel_module_panel__ee004986.Panel_module_teal__ee004986 > h2 {\n  background-color: #38808a;\n}\n/* Styles for the Panel component */\n.CountdownContainer_module_countdownContainer__8236de2c {\n  display: grid;\n  grid-template-columns: 3fr 1fr;\n  justify-content: space-evenly;\n  align-items: center;\n  height: 100%;\n}\n.CountdownContainer_module_countdownContainer__8236de2c.CountdownContainer_module_completed__8236de2c {\n  grid-template-columns: 1fr;\n}\n\np.CountdownContainer_module_countdownCompleted__8236de2c {\n  text-align: center;\n  font-size: 2em;\n  font-weight: 700;\n  color: #ffa900;\n  padding: 0;\n  margin: 0;\n}\n/* Styles for the StudyType component */\n.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a {\n  text-align: right;\n  font-size: 0.6em;\n}\n.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a dl {\n  margin: 0.25em 1em;\n}\n.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a dl dd {\n  display: inline;\n  margin: 0;\n}\n.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a dl dd::before {\n  display: inline-block;\n  content: \" \";\n  vertical-align: baseline;\n  width: 0.9em;\n  height: 0.9em;\n  border-radius: 0.45em;\n  margin-left: 0.75em;\n  margin-right: 0.25em;\n}\n.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a dl dd.RecentActivity_module_votes__5759898a::before {\n  background-color: #390099;\n}\n.RecentActivity_module_container__5759898a .RecentActivity_module_chartKey__5759898a dl dd.RecentActivity_module_voters__5759898a::before {\n  background-color: #ff005c;\n}\n.RecentActivity_module_container__5759898a svg .axis line {\n  stroke-width: 0.21em;\n  shape-rendering: crispEdges;\n}\n.RecentActivity_module_container__5759898a svg .axis .minor line {\n  stroke: #888;\n  stroke-width: 0.14em;\n}\n.RecentActivity_module_container__5759898a svg .axis path {\n  display: none;\n}\n/* Styles for the StudyType component */\n.StudyType_module_studyType__62789536 {\n  display: flex;\n  width: 100%;\n}\n.StudyType_module_studyType__62789536 .StudyType_module_barContainer__62789536 {\n  width: 80%;\n  background-color: white;\n  margin: 0 0.5em 0.5em;\n}\n.StudyType_module_studyType__62789536 .StudyType_module_barContainer__62789536 .StudyType_module_bar__62789536 {\n  width: 0;\n  height: 100%;\n  background-color: #ffa900;\n  transition: width 0.75s ease;\n}\n.StudyType_module_studyType__62789536 .StudyType_module_label__62789536 {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 20%;\n  margin: -0.25em 0 0.5em;\n  font-size: 0.9em;\n  font-weight: 800;\n}\n/* Styles for the StudyTypes component */\n.StudyTypes_module_container__06fe834f {\n  background-color: #390099;\n  display: flex;\n  justify-content: space-around;\n  height: 100%;\n  color: white;\n}\n\n@media screen and (max-width: 1140px) and (orientation: portrait) {\n  .StudyTypes_module_container__06fe834f {\n    flex-direction: column;\n  }\n}\n/* Styles for the TimeLineEntry component */\n.TimeLineEntry_module_timeLineEntry__59e1e3ba {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5em 0.125em;\n  text-align: center;\n  transition: background-color 2s ease-in-out, color 2s ease-in-out, box-shadow 2s ease-in-out;\n}\n.TimeLineEntry_module_timeLineEntry__59e1e3ba .TimeLineEntry_module_intervalLabel__59e1e3ba {\n  font-size: 0.875em;\n}\n.TimeLineEntry_module_timeLineEntry__59e1e3ba .TimeLineEntry_module_countContainer__59e1e3ba {\n  line-height: 0.9em;\n}\n.TimeLineEntry_module_timeLineEntry__59e1e3ba .TimeLineEntry_module_count__59e1e3ba {\n  font-size: 1.125em;\n  font-weight: 700;\n}\n.TimeLineEntry_module_timeLineEntry__59e1e3ba .TimeLineEntry_module_countLabel__59e1e3ba {\n  font-size: 0.625em;\n  font-weight: 700;\n}\n\n.TimeLineEntry_module_rising__59e1e3ba, .TimeLineEntry_module_falling__59e1e3ba {\n  transition: none;\n}\n\n.TimeLineEntry_module_rising__59e1e3ba {\n  background-color: #ffa900;\n  color: #390099;\n  box-shadow: 0 0 0.1em 0.05em #ffa900;\n}\n\n.TimeLineEntry_module_falling__59e1e3ba {\n  background-color: #ff005c;\n  box-shadow: 0 0 0.1em 0.05em #ff005c;\n  color: #ffa900;\n}\n/* Styles for the TimeLine component */\n.TimeLine_module_container__6059004b {\n  display: grid;\n  grid-template-columns: 3fr 5fr 5fr 5fr;\n  column-gap: 0.75em;\n  align-items: center;\n  padding: 0 0.75em 0 0.55em;\n  background-color: #38808a;\n  color: white;\n  height: 100%;\n}\n.TimeLine_module_container__6059004b h2 {\n  color: white;\n  font-size: 1.125em;\n}\n\n@media screen and (max-width: 1140px) and (orientation: portrait) {\n  .TimeLine_module_container__6059004b {\n    height: 4.35em;\n  }\n}\n/* Styles for the TotalStats component */\n.TotalStats_module_totalStat__ef818f01 {\n  position: relative;\n  display: flex;\n  justify-content: space-evenly;\n  align-content: center;\n  align-items: center;\n  height: 100%;\n  color: #390099;\n}\n.TotalStats_module_totalStat__ef818f01 .TotalStats_module_percentage__ef818f01 {\n  font-size: 3em;\n  font-weight: 800;\n}\n.TotalStats_module_totalStat__ef818f01 .TotalStats_module_countContainer__ef818f01 {\n  font-size: 1.5em;\n  font-weight: 700;\n}\n.TotalStats_module_totalStat__ef818f01.TotalStats_module_cspStat__ef818f01 {\n  color: #38808a;\n}\n.TotalStats_module_totalStat__ef818f01 .TotalStats_module_connectionStatus__ef818f01 {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 0.2em;\n  height: 0.2em;\n  z-index: 1;\n}\n.TotalStats_module_totalStat__ef818f01 .TotalStats_module_connectionStatus__ef818f01.TotalStats_module_disconnected__ef818f01 {\n  background-color: #ff005c;\n}\n.TotalStats_module_totalStat__ef818f01 .TotalStats_module_connectionStatus__ef818f01.TotalStats_module_connected__ef818f01 {\n  background-color: green;\n}\n/* Styles for the StudyType component */\n.ConstituentUnion_module_cus__68c20bd0 {\n  display: flex;\n  align-items: center;\n  padding: 0.1em 0;\n}\n.ConstituentUnion_module_cus__68c20bd0:nth-child(1) {\n  -ms-transform: translate(0, 0%);\n  -webkit-transform: translate3d(0, 0%, 0);\n  transform: translate3d(0, 0%, 0);\n}\n.ConstituentUnion_module_cus__68c20bd0::before {\n  display: inline-block;\n  content: counter(item);\n  counter-increment: item;\n  color: #390099;\n  background-color: #ffa900;\n  width: 1.325em;\n  height: 1.3em;\n  line-height: 1.3;\n  border-radius: 0.64em;\n  text-align: center;\n  font-size: 1.2em;\n  font-weight: 700;\n}\n.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_content__68c20bd0 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: calc(100% - 1.2em);\n}\n.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_barcontainer__68c20bd0 {\n  flex: 1 0 auto;\n  position: relative;\n  height: 1.25em;\n  vertical-align: middle;\n  margin-left: -0.9em;\n  z-index: -1;\n  background: none;\n}\n.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_barcontainer__68c20bd0 .ConstituentUnion_module_bar__68c20bd0 {\n  position: absolute;\n  box-sizing: content-box;\n  background-color: #92ced3;\n  border-radius: 0;\n  width: 0;\n  height: 1.25em;\n  padding-left: 0.9em;\n  -webkit-transition: width 1s ease;\n  transition: width 1s ease;\n}\n.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_barcontainer__68c20bd0 .ConstituentUnion_module_info__68c20bd0 {\n  margin-left: 1.5em;\n  text-align: left;\n  position: relative;\n  z-index: 3;\n  padding-right: 0.25em;\n  font-size: 0.75em;\n}\n.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_barcontainer__68c20bd0 .ConstituentUnion_module_info__68c20bd0 .ConstituentUnion_module_label__68c20bd0 {\n  vertical-align: middle;\n  font-weight: 700;\n  color: #390099;\n}\n.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_percentage__68c20bd0 {\n  flex: 0 1 3.5em;\n  padding-right: 5px;\n  text-align: right;\n  font-size: 1em;\n  font-weight: 700;\n  color: #390099;\n  vertical-align: middle;\n}\n.ConstituentUnion_module_cus__68c20bd0 .ConstituentUnion_module_icon__68c20bd0 {\n  flex: 0 1 auto;\n  height: 1.8em;\n  width: 1.8em;\n}\n/* Styles for the StudyType component */\n.ConstituentUnions_module_container__083a9e87 {\n  height: 100%;\n  overflow: hidden;\n}\n\nol.ConstituentUnions_module_list__083a9e87 {\n  counter-reset: item;\n  -webkit-transition: top 0.5s ease-out;\n  transition: top 0.5s ease-out;\n  margin-left: 0;\n  margin: 0;\n  padding: 0.5em 0.5em 0;\n}\n/* Styles for the TopTurnoutList component */\n.TopTurnoutEntry_module_entry__d3f8bcf4 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.1em 0;\n}\n.TopTurnoutEntry_module_entry__d3f8bcf4::before {\n  flex: 0 1 auto;\n  display: inline-block;\n  content: counter(item);\n  counter-increment: item;\n  color: #390099;\n  background-color: #ffa900;\n  width: 1.3em;\n  height: 1.3em;\n  line-height: 1.3;\n  border-radius: 0.65em;\n  text-align: center;\n  font-size: 1.2em;\n  font-weight: 700;\n}\n.TopTurnoutEntry_module_entry__d3f8bcf4:nth-child(n+10):nth-child(-n+99)::before {\n  font-size: 1em;\n  width: 1.56em;\n  height: 1.56em;\n  border-radius: 0.78em;\n  line-height: 1.56;\n}\n.TopTurnoutEntry_module_entry__d3f8bcf4:nth-child(n+100)::before {\n  font-size: 0.75em;\n  width: 2.08em;\n  height: 2.08em;\n  border-radius: 1.04em;\n  line-height: 2.08;\n}\n.TopTurnoutEntry_module_entry__d3f8bcf4 .TopTurnoutEntry_module_label__d3f8bcf4 {\n  flex: 1 0 auto;\n  margin-left: 0.5em;\n  text-align: left;\n  font-weight: 700;\n  font-size: 0.75em;\n  line-height: 1em;\n  max-width: 80%;\n  color: #390099;\n}\n.TopTurnoutEntry_module_entry__d3f8bcf4 .TopTurnoutEntry_module_percentage__d3f8bcf4 {\n  flex: 0 1 auto;\n  padding-right: 5px;\n  text-align: right;\n  font-size: 1em;\n  font-weight: 700;\n  color: #390099;\n  vertical-align: middle;\n}\n/* Styles for the TopTurnoutList component */\n.TopTurnoutList_module_container__29035d8e {\n  font-size: 1em;\n}\n\nol.TopTurnoutList_module_entrylist__29035d8e {\n  counter-reset: item;\n  -webkit-transition: top 0.5s ease-out;\n  transition: top 0.5s ease-out;\n  margin: 0 0 0.5em;\n  padding: 0.5em;\n  height: 7.5em;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  scrollbar-color: #92ced3 #dbeff0;\n  scrollbar-width: thin;\n}\nol.TopTurnoutList_module_entrylist__29035d8e::-webkit-scrollbar-thumb {\n  background-color: #92ced3;\n}\nol.TopTurnoutList_module_entrylist__29035d8e::-webkit-scrollbar-track {\n  background-color: #dbeff0;\n}\nol.TopTurnoutList_module_entrylist__29035d8e::-webkit-scrollbar-corner {\n  background-color: #dbeff0;\n}\nol.TopTurnoutList_module_entrylist__29035d8e::-webkit-scrollbar {\n  width: 0.5rem;\n}\n/* Styles for the ElectionProgress component */\n.ElectionProgress_module_container__aeb63221 {\n  position: relative;\n  height: 100%;\n  padding: 0 0.5em;\n  overflow: hidden;\n  background-color: #390099;\n  color: white;\n  z-index: 1;\n}\n\n@media screen and (max-width: 1140px) and (orientation: portrait) {\n  .ElectionProgress_module_container__aeb63221 {\n    height: 5em;\n  }\n}\nul.ElectionProgress_module_markers__aeb63221 {\n  margin: 0;\n  padding: 1.25em 2em 0 0.75em;\n  list-style: none;\n}\nul.ElectionProgress_module_markers__aeb63221 li {\n  position: absolute;\n  display: block;\n  z-index: 2;\n  transition: width 0.75s ease;\n}\nul.ElectionProgress_module_markers__aeb63221 li span {\n  position: absolute;\n  top: 0.3em;\n  right: 0.3em;\n  font-size: 0.7em;\n  font-weight: 700;\n  writing-mode: vertical-rl;\n}\nul.ElectionProgress_module_markers__aeb63221 li[data-tooltip]:not([data-tooltip=\"\"]) span {\n  text-decoration: underline dotted;\n}\nul.ElectionProgress_module_markers__aeb63221 li[data-tooltip]:not([data-tooltip=\"\"]):hover::before, ul.ElectionProgress_module_markers__aeb63221 li[data-tooltip]:not([data-tooltip=\"\"]):focus::before, ul.ElectionProgress_module_markers__aeb63221 li[data-tooltip]:not([data-tooltip=\"\"]):active::before {\n  content: attr(data-tooltip);\n  display: block;\n  position: absolute;\n  z-index: 3;\n  top: 0.5em;\n  right: 2em;\n  background-color: white;\n  color: black;\n  border: 1px solid #888;\n  padding: 0.5em;\n  font-size: 0.6em;\n}\nul.ElectionProgress_module_markers__aeb63221 li::after {\n  content: \" \";\n  position: absolute;\n  top: -0.25em;\n  right: 0;\n  width: 0.2em;\n  height: 2.75em;\n  background-color: white;\n}\nul.ElectionProgress_module_markers__aeb63221 li.ElectionProgress_module_tick__aeb63221 span {\n  top: -1.75em;\n  right: -1em;\n  writing-mode: horizontal-tb;\n}\nul.ElectionProgress_module_markers__aeb63221 li.ElectionProgress_module_tick__aeb63221::after {\n  width: 0.1em;\n  background-color: rgba(255, 255, 255, 0.75);\n}\n\n.ElectionProgress_module_currentYear__aeb63221 {\n  position: absolute;\n  left: 0.75em;\n  display: block;\n  height: 2em;\n  padding-left: 0.5em;\n  background-color: #ffa900;\n  box-shadow: -0.2em 0.2em 0 0 #ff005c;\n  transition: width 2s cubic-bezier(0.5, 1, 0.89, 1);\n}\n/* Styles for the Milestone component */\n.Milestone_module_container__36efb943 {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #9e0059;\n  color: white;\n  transition: none;\n}\n.Milestone_module_container__36efb943.Milestone_module_finished__36efb943 {\n  background-color: #390099;\n  color: #390099;\n  transition: all 1s ease-out;\n}\n\n.Milestone_module_loadEffect__36efb943 {\n  transition: none;\n  transform: scale(0.1);\n}\n.Milestone_module_loadEffect__36efb943.Milestone_module_loaded__36efb943 {\n  transition: all 1s ease-out;\n  transform: scale(1);\n}\n\n.Milestone_module_message__36efb943 {\n  font-size: 1.5em;\n  font-weight: 600;\n}\n/* Styles for the Dashboard component */\n.Dashboard_module_dashboard__2db5910f {\n  display: grid;\n  aspect-ratio: 16/9;\n  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr;\n  grid-template-rows: 1fr 1fr 1.45fr 1.05fr 3fr 1.5fr;\n  gap: 1px;\n  font-size: calc(8px + 8 * (100vw - 585px) / 585);\n}\n.Dashboard_module_dashboard__2db5910f.Dashboard_module_maxWidth1170__2db5910f {\n  max-width: 1170px;\n  font-size: clamp(8px, 16px, 8px + 8 * (100vw - 585px) / 585);\n}\n\n.Dashboard_module_grid__2db5910f {\n  height: 100%;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_votingCloses__2db5910f, .Dashboard_module_grid__2db5910f.Dashboard_module_milestone__2db5910f {\n  grid-column: 2/span 6;\n  grid-row: 1/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_logo__2db5910f {\n  grid-column: 1/span 1;\n  grid-row: 1/span 2;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_totalMain__2db5910f {\n  grid-column: 2/span 3;\n  grid-row: 3/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_totalCSPs__2db5910f {\n  grid-column: 5/span 3;\n  grid-row: 3/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_recentActivity__2db5910f {\n  grid-column: 1/span 1;\n  grid-row: 3/span 2;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_studyTypes__2db5910f {\n  grid-column: 2/span 6;\n  grid-row: 4/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_sourceToggle__2db5910f {\n  grid-column: 7/span 1;\n  grid-row: 2/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_timeLine__2db5910f {\n  grid-column: 2/span 5;\n  grid-row: 2/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_CUs__2db5910f {\n  grid-column: 1/span 1;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_depts__2db5910f {\n  grid-column: 2/span 2;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_CSPs__2db5910f {\n  grid-column: 4/span 2;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_halls__2db5910f {\n  grid-column: 6/span 2;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_progress__2db5910f {\n  grid-column: 1/span 7;\n  grid-row: 6/span 1;\n}\n\n.Dashboard_module_sourceToggle__2db5910f {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-align: center;\n  padding: 0.5em;\n  height: calc(100% - 1em);\n}\n.Dashboard_module_sourceToggle__2db5910f > span {\n  font-size: 0.7em;\n}\n\n.Dashboard_module_votingCloses__2db5910f {\n  background-color: #390099;\n}\n\n.Dashboard_module_loader__2db5910f {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n@media screen and (max-width: 1140px) and (orientation: portrait) {\n  .Dashboard_module_dashboard__2db5910f {\n    display: grid;\n    aspect-ratio: initial;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto;\n    gap: 1px;\n    font-size: calc(8px + 8 * (100vw - 360px) / 360);\n  }\n  .Dashboard_module_dashboard__2db5910f.Dashboard_module_maxWidth1170__2db5910f {\n    font-size: calc(8px + 8 * (100vw - 360px) / 360);\n  }\n  .Dashboard_module_grid__2db5910f {\n    height: auto;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_votingCloses__2db5910f, .Dashboard_module_grid__2db5910f.Dashboard_module_milestone__2db5910f {\n    grid-column: 1/span 2;\n    grid-row: 2/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_logo__2db5910f {\n    grid-column: 1/span 2;\n    grid-row: 1/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_totalMain__2db5910f {\n    grid-column: 1/span 1;\n    grid-row: 3/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_totalCSPs__2db5910f {\n    grid-column: 2/span 1;\n    grid-row: 3/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_recentActivity__2db5910f {\n    grid-column: 1/span 1;\n    grid-row: 5/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_studyTypes__2db5910f {\n    grid-column: 2/span 1;\n    grid-row: 5/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_sourceToggle__2db5910f {\n    grid-column: 1/span 2;\n    grid-row: 6/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_timeLine__2db5910f {\n    grid-column: 1/span 2;\n    grid-row: 4/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_CUs__2db5910f {\n    grid-column: 1/span 1;\n    grid-row: 7/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_depts__2db5910f {\n    grid-column: 2/span 1;\n    grid-row: 7/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_CSPs__2db5910f {\n    grid-column: 1/span 1;\n    grid-row: 8/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_halls__2db5910f {\n    grid-column: 2/span 1;\n    grid-row: 8/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_progress__2db5910f {\n    grid-column: 1/span 2;\n    grid-row: 9/span 1;\n  }\n  .Dashboard_module_sourceToggle__2db5910f {\n    height: 3.25em;\n  }\n}\n.RollingTimeFrame_module_container__f1acef40 {\n  display: flex;\n  justify-content: center;\n  column-gap: 0.3em;\n  margin: 0.5em 0;\n  box-sizing: border-box;\n}\n.RollingTimeFrame_module_container__f1acef40 .RollingTimeFrame_module_btn__f1acef40 {\n  font-size: 0.75em;\n  font-weight: 800;\n  background-color: transparent;\n  color: #38808a;\n  box-shadow: none;\n  padding: 0.5em 0.55em;\n  border: 1px solid #ffa900;\n  vertical-align: middle;\n  transition: background-color 0.25s ease-out, color 0.25s ease-out;\n  width: 21.5%;\n  line-height: 1;\n}\n.RollingTimeFrame_module_container__f1acef40 .RollingTimeFrame_module_btn__f1acef40:hover {\n  background-color: #ffa900;\n  border-color: #ffa900;\n  color: #38808a;\n}\n.RollingTimeFrame_module_container__f1acef40 .RollingTimeFrame_module_active__f1acef40 {\n  font-size: 0.75em;\n  font-weight: 800;\n  background-color: #ffa900;\n  padding: 0.5em 0.55em;\n  border: 1px solid #ffa900;\n  color: #38808a;\n  width: 21.5%;\n  line-height: 1;\n}\n/* Styles for the Dashboard component */\n.StepByStep_module_stepContainer__2745d666 {\n  max-width: 1170px;\n  text-align: center;\n}\n.StepByStep_module_stepContainer__2745d666 .StepByStep_module_paragraph__2745d666 {\n  margin: 2em;\n}\n/* Styles for the le2023 Logo component */\n.Logo_module_container__a4a750ff {\n  background: linear-gradient(0deg, #390099 50%, #38808a 50%);\n}\n.Logo_module_container__a4a750ff a {\n  display: flex;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n.Logo_module_container__a4a750ff a img {\n  margin-top: 0.45em;\n  margin-bottom: -0.1em;\n}\n/* Styles for the Dashboard component */\n.Dashboard_module_dashboard__2db5910f {\n  display: grid;\n  aspect-ratio: 16/9;\n  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr;\n  grid-template-rows: 1fr 1fr 1.45fr 1.05fr 3fr 1.5fr;\n  gap: 1px;\n  font-size: calc(8px + 8 * (100vw - 585px) / 585);\n}\n.Dashboard_module_dashboard__2db5910f.Dashboard_module_maxWidth1170__2db5910f {\n  max-width: 1170px;\n  font-size: clamp(8px, 16px, 8px + 8 * (100vw - 585px) / 585);\n}\n\n.Dashboard_module_grid__2db5910f {\n  height: 100%;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_votingCloses__2db5910f, .Dashboard_module_grid__2db5910f.Dashboard_module_milestone__2db5910f {\n  grid-column: 2/span 6;\n  grid-row: 1/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_logo__2db5910f {\n  grid-column: 1/span 1;\n  grid-row: 1/span 2;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_totalMain__2db5910f {\n  grid-column: 2/span 3;\n  grid-row: 3/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_totalCSPs__2db5910f {\n  grid-column: 5/span 3;\n  grid-row: 3/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_recentActivity__2db5910f {\n  grid-column: 1/span 1;\n  grid-row: 3/span 2;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_studyTypes__2db5910f {\n  grid-column: 2/span 6;\n  grid-row: 4/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_sourceToggle__2db5910f {\n  grid-column: 7/span 1;\n  grid-row: 2/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_timeLine__2db5910f {\n  grid-column: 2/span 5;\n  grid-row: 2/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_CUs__2db5910f {\n  grid-column: 1/span 1;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_depts__2db5910f {\n  grid-column: 2/span 2;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_CSPs__2db5910f {\n  grid-column: 4/span 2;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_halls__2db5910f {\n  grid-column: 6/span 2;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__2db5910f.Dashboard_module_progress__2db5910f {\n  grid-column: 1/span 7;\n  grid-row: 6/span 1;\n}\n\n.Dashboard_module_sourceToggle__2db5910f {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-align: center;\n  padding: 0.5em;\n  height: calc(100% - 1em);\n}\n.Dashboard_module_sourceToggle__2db5910f > span {\n  font-size: 0.7em;\n}\n\n.Dashboard_module_votingCloses__2db5910f {\n  background-color: #390099;\n}\n\n.Dashboard_module_loader__2db5910f {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n@media screen and (max-width: 1140px) and (orientation: portrait) {\n  .Dashboard_module_dashboard__2db5910f {\n    display: grid;\n    aspect-ratio: initial;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto;\n    gap: 1px;\n    font-size: calc(8px + 8 * (100vw - 360px) / 360);\n  }\n  .Dashboard_module_dashboard__2db5910f.Dashboard_module_maxWidth1170__2db5910f {\n    font-size: calc(8px + 8 * (100vw - 360px) / 360);\n  }\n  .Dashboard_module_grid__2db5910f {\n    height: auto;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_votingCloses__2db5910f, .Dashboard_module_grid__2db5910f.Dashboard_module_milestone__2db5910f {\n    grid-column: 1/span 2;\n    grid-row: 2/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_logo__2db5910f {\n    grid-column: 1/span 2;\n    grid-row: 1/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_totalMain__2db5910f {\n    grid-column: 1/span 1;\n    grid-row: 3/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_totalCSPs__2db5910f {\n    grid-column: 2/span 1;\n    grid-row: 3/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_recentActivity__2db5910f {\n    grid-column: 1/span 1;\n    grid-row: 5/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_studyTypes__2db5910f {\n    grid-column: 2/span 1;\n    grid-row: 5/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_sourceToggle__2db5910f {\n    grid-column: 1/span 2;\n    grid-row: 6/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_timeLine__2db5910f {\n    grid-column: 1/span 2;\n    grid-row: 4/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_CUs__2db5910f {\n    grid-column: 1/span 1;\n    grid-row: 7/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_depts__2db5910f {\n    grid-column: 2/span 1;\n    grid-row: 7/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_CSPs__2db5910f {\n    grid-column: 1/span 1;\n    grid-row: 8/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_halls__2db5910f {\n    grid-column: 2/span 1;\n    grid-row: 8/span 1;\n  }\n  .Dashboard_module_grid__2db5910f.Dashboard_module_progress__2db5910f {\n    grid-column: 1/span 2;\n    grid-row: 9/span 1;\n  }\n  .Dashboard_module_sourceToggle__2db5910f {\n    height: 3.25em;\n  }\n}\n/* Styles for the Dashboard component */\n.StepByStep_module_stepContainer__2745d666 {\n  max-width: 1170px;\n  text-align: center;\n}\n.StepByStep_module_stepContainer__2745d666 .StepByStep_module_paragraph__2745d666 {\n  margin: 2em;\n}\n/* Styles for the le2024 Logo component */\n.Logo_module_container__d3dc2f40 {\n  background: linear-gradient(0deg, #390099 50%, #38808a 50%);\n  height: 100%;\n}\n.Logo_module_container__d3dc2f40 a {\n  display: flex;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n.Logo_module_container__d3dc2f40 a img {\n  margin-top: 1.46em;\n  margin-bottom: -0.1em;\n}\n/* Styles for the Dashboard component */\n.Dashboard_module_dashboard__bd53cb77 {\n  display: grid;\n  aspect-ratio: 16/9;\n  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr;\n  grid-template-rows: 1fr 1fr 1.45fr 1.05fr 3fr 1.5fr;\n  gap: 1px;\n  font-size: calc(8px + 8 * (100vw - 585px) / 585);\n}\n.Dashboard_module_dashboard__bd53cb77.Dashboard_module_maxWidth1170__bd53cb77 {\n  max-width: 1170px;\n  font-size: clamp(8px, 16px, 8px + 8 * (100vw - 585px) / 585);\n}\n\n.Dashboard_module_grid__bd53cb77 {\n  height: 100%;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_votingCloses__bd53cb77, .Dashboard_module_grid__bd53cb77.Dashboard_module_milestone__bd53cb77 {\n  grid-column: 2/span 6;\n  grid-row: 1/span 1;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_logo__bd53cb77 {\n  grid-column: 1/span 1;\n  grid-row: 1/span 2;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_totalMain__bd53cb77 {\n  grid-column: 2/span 3;\n  grid-row: 3/span 1;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_totalCSPs__bd53cb77 {\n  grid-column: 5/span 3;\n  grid-row: 3/span 1;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_recentActivity__bd53cb77 {\n  grid-column: 1/span 1;\n  grid-row: 3/span 2;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_studyTypes__bd53cb77 {\n  grid-column: 2/span 6;\n  grid-row: 4/span 1;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_sourceToggle__bd53cb77 {\n  grid-column: 7/span 1;\n  grid-row: 2/span 1;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_timeLine__bd53cb77 {\n  grid-column: 2/span 5;\n  grid-row: 2/span 1;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_CUs__bd53cb77 {\n  grid-column: 1/span 1;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_depts__bd53cb77 {\n  grid-column: 2/span 2;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_CSPs__bd53cb77 {\n  grid-column: 4/span 2;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_halls__bd53cb77 {\n  grid-column: 6/span 2;\n  grid-row: 5/span 1;\n}\n.Dashboard_module_grid__bd53cb77.Dashboard_module_progress__bd53cb77 {\n  grid-column: 1/span 7;\n  grid-row: 6/span 1;\n}\n\n.Dashboard_module_sourceToggle__bd53cb77 {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-align: center;\n  padding: 0.5em;\n  height: calc(100% - 1em);\n}\n.Dashboard_module_sourceToggle__bd53cb77 > span {\n  font-size: 0.7em;\n}\n\n.Dashboard_module_votingCloses__bd53cb77 {\n  background-color: #390099;\n}\n\n.Dashboard_module_loader__bd53cb77 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n@media screen and (max-width: 1140px) and (orientation: portrait) {\n  .Dashboard_module_dashboard__bd53cb77 {\n    display: grid;\n    aspect-ratio: initial;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto;\n    gap: 1px;\n    font-size: calc(8px + 8 * (100vw - 360px) / 360);\n  }\n  .Dashboard_module_dashboard__bd53cb77.Dashboard_module_maxWidth1170__bd53cb77 {\n    font-size: calc(8px + 8 * (100vw - 360px) / 360);\n  }\n  .Dashboard_module_grid__bd53cb77 {\n    height: auto;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_votingCloses__bd53cb77, .Dashboard_module_grid__bd53cb77.Dashboard_module_milestone__bd53cb77 {\n    grid-column: 1/span 2;\n    grid-row: 2/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_logo__bd53cb77 {\n    grid-column: 1/span 2;\n    grid-row: 1/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_totalMain__bd53cb77 {\n    grid-column: 1/span 1;\n    grid-row: 3/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_totalCSPs__bd53cb77 {\n    grid-column: 2/span 1;\n    grid-row: 3/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_recentActivity__bd53cb77 {\n    grid-column: 1/span 1;\n    grid-row: 5/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_studyTypes__bd53cb77 {\n    grid-column: 2/span 1;\n    grid-row: 5/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_sourceToggle__bd53cb77 {\n    grid-column: 1/span 2;\n    grid-row: 9/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_timeLine__bd53cb77 {\n    grid-column: 1/span 2;\n    grid-row: 4/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_CUs__bd53cb77 {\n    grid-column: 1/span 1;\n    grid-row: 6/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_depts__bd53cb77 {\n    grid-column: 2/span 1;\n    grid-row: 6/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_CSPs__bd53cb77 {\n    grid-column: 1/span 1;\n    grid-row: 7/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_halls__bd53cb77 {\n    grid-column: 2/span 1;\n    grid-row: 7/span 1;\n  }\n  .Dashboard_module_grid__bd53cb77.Dashboard_module_progress__bd53cb77 {\n    grid-column: 1/span 2;\n    grid-row: 8/span 1;\n  }\n  .Dashboard_module_sourceToggle__bd53cb77 {\n    font-size: 1.25em;\n    flex-direction: row;\n    height: 2em;\n  }\n  .Dashboard_module_sourceToggle__bd53cb77 span[data-tooltip]:not([data-tooltip=\"\"]):hover::before, .Dashboard_module_sourceToggle__bd53cb77 span[data-tooltip]:not([data-tooltip=\"\"]):focus::before, .Dashboard_module_sourceToggle__bd53cb77 span[data-tooltip]:not([data-tooltip=\"\"]):active::before {\n    top: initial;\n    right: initial;\n    bottom: 0.5em;\n    left: 3em;\n  }\n}\n/* Styles for the Dashboard component */\n.StepByStep_module_stepContainer__2745d666 {\n  max-width: 1170px;\n  text-align: center;\n}\n.StepByStep_module_stepContainer__2745d666 .StepByStep_module_paragraph__2745d666 {\n  margin: 2em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
